import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';
import fp from 'lodash/fp';
import { connect } from 'react-redux';
import { ButtonBase as Button } from '@deerplusofficial/pos-components';
import {
  color,
  toCurrency,
  getDiscountValue,
} from '@deerplusofficial/pos-helper';
import actions from '../../actions';

const Container = styled(Button)`
  margin-bottom: 12px;
  width: 100%;
  text-align: left;
  border-bottom: 1px solid ${color.border};
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 4px;
`;

const Info = styled.div`
  display: flex;
  align-items: baseline;
  font-size: 16px;
  padding-bottom: 2px;
`;

const Name = styled.div`
  flex: 2 1;
`;

const Specs = styled.div`
  padding: 2px 0;
  font-size: 12px;
  color: ${color.text.secondary};
`;

const Discount = Specs.extend`
  display: flex;
`;

const DiscountName = styled.div`
  flex: 3 0;
`;

const DiscountValue = styled.div`
  flex: 1 0;
  text-align: right;
  white-space: nowrap;
`;

const Amount = styled.div`
  flex: 1 0;
  text-align: center;
  color: ${color.text.title};
`;

const Subtotal = DiscountValue.extend`
  color: ${color.text.price};
`;

const getSpecsString = fp.compose(
  fp.join('、'),
  fp.map((content, spec) => !_.isNull(content) && content)
);

class ItemRow extends PureComponent {
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    quantity: PropTypes.number,
    retail_price: PropTypes.number,
    unit_price: PropTypes.number,
    specs: PropTypes.shape(),
    discount: PropTypes.shape({
      type: PropTypes.number,
      criteria: PropTypes.number,
      id: PropTypes.string,
      value: PropTypes.number,
      formattedValue: PropTypes.string,
      name: PropTypes.string,
    }),
    openProductModal: PropTypes.func,
  };

  static defaultProps = {
    id: '',
    name: '',
    quantity: 1,
    retail_price: 0,
    unit_price: undefined,
    specs: {},
    discount: {},
    openProductModal: _.identity,
  };

  onClick = () => {
    const {
      openProductModal,
      specs,
      quantity,
      productId,
      discount: productDiscount,
    } = this.props;

    openProductModal({
      productId,
      specs,
      quantity,
      productDiscount,
      editMode: true,
    });
  };

  get discountValue() {
    const {
      quantity,
      discount: { formattedValue, type },
    } = this.props;

    return getDiscountValue({
      quantity,
      formattedValue,
      isDiscountPlan: type === 1,
      price: this.price,
    });
  }

  get price() {
    const { retail_price, unit_price } = this.props;

    return unit_price || retail_price;
  }

  render() {
    const { id, name, quantity, specs, discount, ...props } = this.props;

    return (
      <Container value={id} onClick={this.onClick} {...props}>
        <Inner>
          <Info>
            <Name>{name}</Name>
            <Amount>x{quantity}</Amount>
            <Subtotal>{toCurrency(this.price * quantity)}</Subtotal>
          </Info>
          {Boolean(_.size(specs)) && <Specs>{getSpecsString(specs)}</Specs>}
          {Boolean(_.size(discount)) && (
            <Discount>
              <DiscountName>{discount.name}</DiscountName>
              <DiscountValue>{toCurrency(-this.discountValue)}</DiscountValue>
            </Discount>
          )}
        </Inner>
      </Container>
    );
  }
}

const { open: openProductModal } = actions.productModal;

export default connect(
  null,
  { openProductModal }
)(ItemRow);



// WEBPACK FOOTER //
// ./src/components/Cart/ItemRow.js